(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function setRailActive(track, dots) {
    if (!track || !dots.length) return;
    var cards = Array.from(track.children);
    if (!cards.length) return;
    var closestIndex = 0;
    var smallestDistance = Infinity;
    var trackLeft = track.getBoundingClientRect().left;
    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestIndex = index;
      }
    });
    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === closestIndex);
      dot.setAttribute('aria-current', index === closestIndex ? 'true' : 'false');
    });
  }

  function initRail(scope) {
    var track = scope.querySelector('[data-sunbum-rail-track]');
    if (!track) return;
    var dots = Array.from(scope.querySelectorAll('[data-sunbum-rail-dot]'));
    setRailActive(track, dots);
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        setRailActive(track, dots);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetIndex = Number(dot.getAttribute('data-index') || '0');
        var target = track.children[targetIndex];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });
  }

  function initCategoryNav(scope) {
    var items = Array.from(scope.querySelectorAll('[data-sunbum-category-item]'));
    var preview = scope.querySelector('[data-sunbum-category-preview]');
    var sticker = scope.querySelector('[data-sunbum-category-sticker]');
    if (!preview || !items.length) return;

    function activate(item) {
      items.forEach(function (entry) {
        entry.classList.toggle('is-active', entry === item);
      });
      var previewSrc = item.getAttribute('data-preview-src');
      var previewAlt = item.getAttribute('data-preview-alt') || '';
      var stickerSrc = item.getAttribute('data-sticker-src');
      if (previewSrc) {
        preview.src = previewSrc;
        preview.alt = previewAlt;
      }
      if (sticker) {
        if (stickerSrc) {
          sticker.src = stickerSrc;
          sticker.hidden = false;
        } else {
          sticker.hidden = true;
        }
      }
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item);
      });
      item.addEventListener('focus', function () {
        activate(item);
      });
      item.addEventListener('click', function () {
        activate(item);
      });
    });
  }

  function hydrateDeferredImages(scope) {
    if (!scope) return;
    Array.from(scope.querySelectorAll('[data-sunbum-deferred-image]')).forEach(function (image) {
      var src = image.getAttribute('data-src');
      if (src && image.getAttribute('src') !== src) {
        image.src = src;
        image.removeAttribute('data-src');
      }
      var srcset = image.getAttribute('data-srcset');
      if (srcset) {
        image.srcset = srcset;
        image.removeAttribute('data-srcset');
      }
    });
  }

  function initDeferredBackgrounds() {
    var backgrounds = Array.from(document.querySelectorAll('[data-sunbum-deferred-bg]'));
    if (!backgrounds.length) return;

    function applyBackground(element) {
      if (!element || element.getAttribute('data-bg-loaded') === 'true') return;
      var backgroundUrl = element.getAttribute('data-bg-url');
      if (!backgroundUrl) return;
      element.style.backgroundImage = 'url("' + backgroundUrl.replace(/"/g, '\\"') + '")';
      element.setAttribute('data-bg-loaded', 'true');
    }

    if (!('IntersectionObserver' in window)) {
      backgrounds.forEach(applyBackground);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          applyBackground(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '220px 0px'
    });

    backgrounds.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initHeader() {
    var header = document.querySelector('[data-sunbum-header]');
    if (!header) return;

    var megaToggle = header.querySelector('[data-sunbum-shop-toggle]');
    var mega = header.querySelector('[data-sunbum-shop-menu]');
    if (megaToggle && mega) {
      function closeMega() {
        mega.classList.remove('is-open');
        megaToggle.setAttribute('aria-expanded', 'false');
      }

      megaToggle.addEventListener('click', function () {
        var isOpen = mega.classList.toggle('is-open');
        megaToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          hydrateDeferredImages(mega);
        }
      });

      document.addEventListener('click', function (event) {
        if (!header.contains(event.target)) {
          closeMega();
        }
      });
    }

    var drawer = header.querySelector('[data-sunbum-drawer]');
    var drawerOpen = header.querySelector('[data-sunbum-drawer-open]');
    var drawerCloses = Array.from(header.querySelectorAll('[data-sunbum-drawer-close]'));

    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('sunbum-drawer-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    if (drawer && drawerOpen) {
      drawerOpen.addEventListener('click', function () {
        setDrawer(true);
      });
      drawerCloses.forEach(function (button) {
        button.addEventListener('click', function () {
          setDrawer(false);
        });
      });
    }

    var searchPanels = Array.from(header.querySelectorAll('[data-sunbum-search-panel]'));
    var searchOpens = Array.from(header.querySelectorAll('[data-sunbum-search-open]'));
    var searchCloses = Array.from(header.querySelectorAll('[data-sunbum-search-close]'));

    function setSearch(open) {
      searchPanels.forEach(function (panel) {
        panel.classList.toggle('is-open', open);
      });
    }

    searchOpens.forEach(function (button) {
      button.addEventListener('click', function () {
        setSearch(true);
      });
    });
    searchCloses.forEach(function (button) {
      button.addEventListener('click', function () {
        setSearch(false);
      });
    });

    initCartCount(header);
  }

  function initCartCount(header) {
    var cartLinks = Array.from(header.querySelectorAll('[data-sunbum-cart-link]'));
    var cartCounts = Array.from(header.querySelectorAll('[data-sunbum-cart-count]'));
    if (!cartLinks.length || !cartCounts.length) return;

    function formatCount(count) {
      return count > 99 ? '99+' : String(Math.max(0, count));
    }

    function readVisibleCount() {
      var value = parseInt(cartCounts[0].getAttribute('data-cart-count') || cartCounts[0].textContent || '0', 10);
      return Number.isFinite(value) ? Math.max(0, value) : 0;
    }

    function persistCount(count) {
      try {
        window.sessionStorage.setItem('cart-count', JSON.stringify({
          value: String(count),
          timestamp: Date.now()
        }));
      } catch (_error) {
        return;
      }
    }

    function renderCount(count, shouldPersist) {
      var normalizedCount = Number.isFinite(count) ? Math.max(0, count) : 0;
      var formattedCount = formatCount(normalizedCount);
      cartCounts.forEach(function (countNode) {
        countNode.textContent = formattedCount;
        countNode.setAttribute('data-cart-count', String(normalizedCount));
      });
      cartLinks.forEach(function (link) {
        link.setAttribute('aria-label', normalizedCount === 1 ? 'Cart, 1 item' : 'Cart, ' + normalizedCount + ' items');
      });
      if (shouldPersist !== false) {
        persistCount(normalizedCount);
      }
    }

    function syncFromStorage() {
      try {
        var storedValue = window.sessionStorage.getItem('cart-count');
        if (!storedValue) return false;
        var parsedValue = JSON.parse(storedValue);
        if (!parsedValue || typeof parsedValue.value === 'undefined') return false;
        if (typeof parsedValue.timestamp === 'number' && Date.now() - parsedValue.timestamp > 10000) return false;
        var count = parseInt(parsedValue.value, 10);
        if (!Number.isFinite(count)) return false;
        renderCount(count, false);
        return true;
      } catch (_error) {
        return false;
      }
    }

    function syncFromCart() {
      return fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (!cart || typeof cart.item_count !== 'number') return;
          renderCount(cart.item_count);
        })
        .catch(function () {
          return;
        });
    }

    function scheduleCartSync() {
      window.setTimeout(syncFromCart, 120);
      window.setTimeout(syncFromCart, 900);
    }

    window.__sunbumHeaderCartSync = scheduleCartSync;

    function isCartMutationUrl(url) {
      return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
    }

    if (!window.__sunbumCartFetchPatched && typeof window.fetch === 'function') {
      var originalFetch = window.fetch.bind(window);
      window.fetch = function () {
        var input = arguments[0];
        var url = typeof input === 'string'
          ? input
          : input && typeof input.url === 'string'
            ? input.url
            : '';
        var responsePromise = originalFetch.apply(window, arguments);

        if (isCartMutationUrl(url)) {
          responsePromise
            .then(function (response) {
              if (!response || !response.ok || typeof window.__sunbumHeaderCartSync !== 'function') return;
              window.__sunbumHeaderCartSync();
            })
            .catch(function () {
              return;
            });
        }

        return responsePromise;
      };
      window.__sunbumCartFetchPatched = true;
    }

    if (!window.__sunbumCartSubmitPatched) {
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
        if (typeof window.__sunbumHeaderCartSync === 'function') {
          window.__sunbumHeaderCartSync();
        }
      }, true);
      window.__sunbumCartSubmitPatched = true;
    }

    document.addEventListener('cart:update', function (event) {
      var resourceCount = event && event.detail && event.detail.resource && typeof event.detail.resource.item_count === 'number'
        ? event.detail.resource.item_count
        : null;
      if (resourceCount !== null) {
        renderCount(resourceCount);
        return;
      }

      var source = event && event.detail && event.detail.data ? event.detail.data.source : '';
      var delta = Number(event && event.detail && event.detail.data ? event.detail.data.itemCount : NaN);
      if (source === 'product-form-component' && Number.isFinite(delta)) {
        renderCount(readVisibleCount() + delta);
        syncFromCart();
        return;
      }

      syncFromCart();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        syncFromStorage();
        syncFromCart();
      }
    });

    syncFromStorage();
    syncFromCart();
  }

  ready(function () {
    initHeader();
    initDeferredBackgrounds();
    document.querySelectorAll('[data-sunbum-rail]').forEach(initRail);
    document.querySelectorAll('[data-sunbum-category-nav]').forEach(initCategoryNav);
  });
})();
